module.exports = __webpack_public_path__ + "static/mercadoPublico-61cc057984f518949f71fb35ad65b61b.svg";